import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  /**
   * General message stating that the request has failed
   */
  message: PropTypes.node.isRequired,
  /**
   * List of errors that happened
   */
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
}

/**
 * Snippet for common submission error use cases
 */
function SubmissionError(props) {
  const { message, errors = [] } = props ?? {}

  const errorsArray = Array.isArray(errors) ? errors : [errors]

  return (
    <>
      <div>
        <span className="font-color-danger fas fa-circle-xmark me-2" />
        <span className="text-bold">{message}</span>
      </div>
      <ul>
        {errorsArray.map((errorMessage) => (
          <li key={errorMessage}>{errorMessage}</li>
        ))}
      </ul>
    </>
  )
}

SubmissionError.propTypes = propTypes

export default SubmissionError
